import React from "react";
import { Link } from "react-router-dom";
import BookLink from "./BookLink";
import { ArrowRight } from "lucide-react";
import { images } from "../data/content";

export default function ServiceCard({ service, testIdPrefix = "service", showBookBtn = true }) {
  return (
    <article
      className="group relative bg-warm-white rounded-3xl overflow-hidden shadow-soft lift-on-hover flex flex-col"
      data-testid={`${testIdPrefix}-card-${service.slug}`}
    >
      <div className="aspect-[4/3] overflow-hidden bg-blush">
        <img
          src={images[service.image]}
          alt={service.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
      </div>
      <div className="p-7 flex flex-col flex-1">
        <h3 className="font-serif-display text-2xl leading-tight">{service.title}</h3>
        <p className="mt-2 font-body text-xs tracking-[0.18em] uppercase text-petal">
          {service.duration}
        </p>
        <p className="mt-4 font-body text-charcoal-soft leading-relaxed text-[0.95rem] flex-1">
          {service.description}
        </p>
        <div className="mt-6 flex items-center justify-between border-t border-pale-rose/60 pt-5">
          <div>
            <div className="font-serif-display text-xl text-petal">{service.price}</div>
            <div className="font-body text-[10px] tracking-widest uppercase text-charcoal-soft/70">
              {service.priceNote}
            </div>
          </div>
          {showBookBtn && (
            <BookLink
              
              className="inline-flex items-center gap-2 text-sm font-body text-petal hover:gap-3 transition-[gap] duration-200"
              data-testid={`${testIdPrefix}-book-${service.slug}`}
            >
              Book <ArrowRight size={14} />
            </BookLink>
          )}
        </div>
      </div>
    </article>
  );
}
